import { useEffect, useState, useMemo } from 'react';
import AdminLayout from "../../layouts/AdminLayout";
import {
  Table, Thead, Tbody, Tr, Th, Td, TableContainer,
  Spinner, Text, Link, Box, Input,
  Flex, IconButton, Avatar, VStack, HStack,
  Button, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody,
  FormControl, FormLabel, Select
} from '@chakra-ui/react';
import { FaEdit, FaFileCsv, FaFilePdf } from "react-icons/fa";
import adminService from '../../services/adminService';
import config from '../../constants/config';
import { formatDate, getGender, getUserStatus } from '../../utils/helper';
import { useNavigate } from 'react-router-dom';

import ReactPaginate from "react-paginate";
import { exportToPDF } from '../../utils/pdfExporter';
import { exportToCSV } from '../../utils/csvExporter';

const ITEMS_PER_PAGE = 10;

const UserList = () => {

  const backendUrl = config.apiBaseUrl;
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [selectedId, setSelectedId] = useState(0);
  const [reasionData, setReasionData] = useState([]);
  const [reasionId, setReasionId] = useState(0)
  const [kycReasionId, setkycReasionId] = useState(0)
  const [compReasionId, setcompReasionId] = useState(0)

  const [reasionBlock, setReasionBlock] = useState(false)
  const [reasionKYCBlock, setReasionKYCBlock] = useState(false)
  const [reasionCompBlock, setReasionCompBlock] = useState(false)

  const [Stat, setStat] = useState(0)
  const [CompApprove, setCompApprove] = useState(0)
  const [kycApprove, setKycApprove] = useState(0)

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    getUserList();
    reasionList();
  }, []);

  const getUserList = async () => {
    try {
      const res = await adminService.getUsers();
      if (res.statusCode === 200) {
        setUsers(res.data);
      }
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const reasionList = async () => {
    setReasionData([]);
    let param = {
      type: 0
    };

    try {
      const res = await adminService.getReasions(param);
      setReasionData(res.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleEdit = (row) => {
    setSelectedId(row.uId);
    setStat(row.Stat)
    setCompApprove(row.CompApprove)
    setKycApprove(row.kycApprove)

    onOpen();
  };

  const handleChange = (e) => {
    setStat(Number(e.target.value));
    setReasionBlock(false)
    if (Number(e.target.value) === 1) {
      setReasionBlock(true)
    }
  };

  const handleKYC = (e) => {
    setKycApprove(Number(e.target.value));
    setReasionKYCBlock(false)
    if (Number(e.target.value) === 1) {
      setReasionKYCBlock(true)
    }
  };

  const handleApprove = (e) => {
    setCompApprove(Number(e.target.value));
    setReasionCompBlock(false)
    if (Number(e.target.value) === 1) {
      setReasionCompBlock(true)
    }
  };

  const handleReasion = (e) => {
    setReasionId(Number(e.target.value));
  };

  const handleKYCReasion = (e) => {
    setkycReasionId(Number(e.target.value));
  };

  const handleCompReasion = (e) => {
    setcompReasionId(Number(e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedId > 0 && !isNaN(parseInt(Stat))) {
      let param = {
        uId: selectedId,
        Stat: Stat,
        reasionId: reasionId,
        kycReasionId: kycReasionId,
        compReasionId: compReasionId,
        CompApprove: CompApprove,
        kycApprove: kycApprove
      };

      if (Stat === 1 && reasionId < 1) {
        alert(`Select User Reasion Field`)
        return false;
      }

      if (kycApprove === 1 && kycReasionId < 1) {
        alert(`Select KYC Reasion Field`)
        return false;
      }

      if (CompApprove === 1 && compReasionId < 1) {
        alert(`Select Company Reasion Field`)
        return false;
      }

      try {
        const res = await adminService.updateUser(param)
        if (res.statusCode === 200) {
          onClose();
          alert(res.message)
          setSelectedId(0);
          getUserList();
        }
      } catch (error) {
        if (error.response?.status === 401) {
          alert(error.response.data.message);
        } else {
          alert("Something went wrong. Please try again.");
          console.error(error);
        }
      }
    } else {
      alert(`Select Required Field`)
    }
  }

  const filteredData = useMemo(() => {
    let result = [...users];
    if (search) {
      const lowerSearch = search.toLowerCase();
      result = result.filter((item) =>
      (`${item.FName} ${item.LName}`.toLowerCase().includes(lowerSearch) ||
        (item.MobileNo || '').toLowerCase().includes(lowerSearch) ||
        (item.CompName || '').toLowerCase().includes(lowerSearch) ||
        (item.Email || '').toLowerCase().includes(lowerSearch) ||
        (item.DOB || '').toLowerCase().includes(lowerSearch) ||
        String(item.Stat).includes(lowerSearch))
      );
    }
    if (sortField) {
      result.sort((a, b) => {
        let aVal = a[sortField] ?? '';
        let bVal = b[sortField] ?? '';

        return sortOrder === "asc" ? aVal > bVal ? 1 : -1 : aVal < bVal ? 1 : -1;
      });
    }
    return result;
  }, [users, search, sortField, sortOrder]);

  const pageCount = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const currentData = useMemo(() => {
    const start = page * ITEMS_PER_PAGE;
    return filteredData.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredData, page]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const handlePageChange = ({ selected }) => {
    setPage(selected);
  };

  const exportCSV = () => {
    // data, filename
    exportToCSV(filteredData, "userList.csv")
  };

  const exportPDF = () => {
    const columns = [
      { label: "ID", accessor: "uId" },
      {
        label: "Fullname",
        accessor: (item) =>
          `${item.FName} ${item.LName}`
      },
      { label: "Mobile", accessor: "MobileNo" },
      { label: "Email", accessor: "Email" },
      { label: "DOB", accessor: "DOB" },
      { label: "Gender", accessor: "Gender" },
      { label: "Company", accessor: "CompName" },
      { label: "Status", accessor: "Stat" },
    ];

    exportToPDF({
      data: filteredData,      // your actual data array
      columns,
      fileName: "userList.pdf"
    });
  };


  return (
    <AdminLayout>
      <Box maxW="1000px" mx="auto" px={4}>
        <Box
          bg="white"
          p={6}
          rounded="xl"
          boxShadow="md"
          border="1px solid"
          borderColor="gray.200"
        >
          <Flex justify="space-between" mb={4} flexWrap="wrap" gap={4}>
            <Input
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(0);
              }}
              maxW="300px"
              size="sm"
            />
            <HStack>
              <Button
                size="sm"
                colorScheme="blue"
                leftIcon={<FaFileCsv />}
                onClick={exportCSV}
              >
                CSV
              </Button>
              <Button
                size="sm"
                colorScheme="red"
                leftIcon={<FaFilePdf />}
                onClick={exportPDF}
              >
                PDF
              </Button>
            </HStack>
          </Flex>

          {loading ? (
            <Box textAlign="center" py={10}>
              <Spinner size="xl" />
              <Text mt={4}>Loading users...</Text>
            </Box>
          ) : (
            <>
              <TableContainer overflowX="auto">
                <Table size="sm" variant="simple">
                  <Thead>
                    <Tr>
                      <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("uId")}>ID</Th>
                      <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("Fname")}>Name</Th>
                      <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("MobileNo")}>Contacts</Th>
                      <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("DOB")}>DOB</Th>
                      <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("CompName")}>Company</Th>
                      <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("Stat")}>Status</Th>
                      <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("Paid")}>Subscription</Th>
                      <Th px={2} py={1} cursor="pointer" onClick={() => handleSort("kycApprove")}>KYC</Th>
                      <Th>Files</Th>
                      <Th>Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {currentData.length > 0 ? (
                      currentData.map((user) => (
                        <Tr key={user.uId}>
                          <Td>{user.uId}</Td>
                          <Td
                            onClick={() => navigate(`/admin/userdetail/${user.uId}`)}
                            style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                          >
                            <Avatar
                              src={`${backendUrl}/profile/${user.ProfilePic}`}
                              name={`${user.FName} ${user.LName}`}
                              size="md"
                              mr={3}
                            />
                            {user.FName} {user.LName}
                          </Td>
                          <Td>
                            <Box display="flex" flexDirection="column">
                              <Text>{user.Email}</Text>
                              <Text>{user.MobileNo}</Text>
                            </Box>
                          </Td>
                          <Td>
                            <Box display="flex" flexDirection="column">
                              <Text>{formatDate(user.DOB)}</Text>
                              <Text>{getGender(user.Gender)}</Text>
                            </Box>
                          </Td>
                          <Td>
                            <Box display="flex" flexDirection="column">
                              <Text>{user.CompName}</Text>
                              <Text>{getUserStatus(user.CompApprove)}</Text>
                            </Box>
                          </Td>
                          <Td>{user.Stat === 0 ? 'Enable' : 'Disable'}</Td>
                          <Td>{user.Paid === 5 ? 'Paid' : 'Not Paid'}</Td>
                          <Td>{getUserStatus(user.kycApprove)}</Td>
                          <Td>
                            <VStack align="start" spacing={1}>
                              <Link href={`${backendUrl}/aadhar/${user.Aadhar}`} isExternal color="blue.500">
                                Aadhar
                              </Link>
                              <Link href={`${backendUrl}/license/${user.Licence}`} isExternal color="blue.500">
                                Licence
                              </Link>
                              <Link href={`${backendUrl}/pan/${user.PAN}`} isExternal color="blue.500">
                                PAN
                              </Link>
                            </VStack>
                          </Td>
                          <Td>
                            <IconButton
                              icon={<FaEdit />}
                              aria-label="Edit"
                              borderRadius="full"
                              onClick={() => handleEdit(user)}
                            />

                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={4} px={2} py={1}>
                          <Text textAlign="center">No data found</Text>
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>

              <Box mt={6}>
                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  pageCount={pageCount}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  activeClassName="active"
                  pageClassName="page-item"
                  previousClassName="page-item"
                  nextClassName="page-item"
                  breakClassName="page-item"
                  pageLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  breakLinkClassName="page-link"
                />
              </Box>

              <style>{`
                            .pagination {
                              display: flex;
                              justify-content: center;
                              list-style: none;
                              padding: 0;
                              margin-top: 1rem;
                            }
                            .page-item {
                              margin: 0 5px;
                            }
                            .page-link {
                              padding: 8px 12px;
                              border-radius: 6px;
                              background-color: #e2e8f0;
                              cursor: pointer;
                            }
                            .page-link:hover {
                              background-color: #cbd5e0;
                            }
                            .active .page-link {
                              background-color: #3182ce;
                              color: white;
                            }
                          `}</style>
            </>
          )}
        </Box>

        {/* Chakra UI Modal */}
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Update</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <form onSubmit={handleSubmit}>
                <FormControl>
                  <FormLabel fontSize="sm">User Status</FormLabel>
                  <Select name="Stat" size="sm" onChange={handleChange} value={Stat} >
                    <option value={0}>Enable</option>
                    <option value={1}>Disable</option>
                  </Select>
                </FormControl>

                {reasionBlock && (
                  <FormControl>
                    <FormLabel fontSize="sm">Reasion</FormLabel>
                    <Select name="reasionId" size="sm" onChange={handleReasion} value={reasionId} >
                      <option value={0}>Select</option>
                      {
                        reasionData.map((row, index) => (
                          <option key={row.rId} value={row.rId}>{row.name}</option>
                        ))
                      }

                    </Select>
                  </FormControl>
                )}

                <FormControl>
                  <FormLabel fontSize="sm">KYC Status</FormLabel>
                  <Select name="Stat" size="sm" onChange={handleKYC} value={kycApprove} >
                    <option value={0}>Pending Approval</option>
                    <option value={5}>Approve</option>
                    <option value={1}>Reject</option>
                  </Select>
                </FormControl>

                {reasionKYCBlock && (
                  <FormControl>
                    <FormLabel fontSize="sm">KYC Reasion</FormLabel>
                    <Select name="reasionId" size="sm" onChange={handleKYCReasion} value={kycReasionId} >
                      <option value={0}>Select</option>
                      {
                        reasionData.map((row, index) => (
                          <option key={row.rId} value={row.rId}>{row.name}</option>
                        ))
                      }

                    </Select>
                  </FormControl>
                )}

                <FormControl>
                  <FormLabel fontSize="sm">Approve</FormLabel>
                  <Select name="CompApprove" size="sm" onChange={handleApprove} value={CompApprove} >
                    <option value={0}>Pending Approval</option>
                    <option value={5}>Approve</option>
                    <option value={1}>Reject</option>
                  </Select>
                </FormControl>

                {reasionCompBlock && (
                  <FormControl>
                    <FormLabel fontSize="sm">Approval Reasion</FormLabel>
                    <Select name="reasionId" size="sm" onChange={handleCompReasion} value={compReasionId} >
                      <option value={0}>Select</option>
                      {
                        reasionData.map((row, index) => (
                          <option key={row.rId} value={row.rId}>{row.name}</option>
                        ))
                      }

                    </Select>
                  </FormControl>
                )}

                <Button type="submit" mt={4} colorScheme="blue" size="sm">
                  Update
                </Button>
              </form>
            </ModalBody>

          </ModalContent>
        </Modal>

      </Box>
    </AdminLayout>
  );
};

export default UserList;
